import BaseModel from './base'

class User extends BaseModel {
  constructor(options) {
    const defaults = {
      id: null,
      state: null,
      username: null,
      firstName: null,
      lastName: null,
      fullName: null,
      likesCount: 0,
      visitCount: 0,
      bio: null,
      location: null,
      twitterUrl: null,
      website: null,
      image: null,
      lastActivity: null,
      lastVisitAt: null,
      visitedAt: null,
      showTwitter: true,
      className: 'User',
      blockType: 'PersonBlock',
    }

    super(options, defaults)
  }

  get showTwitterUrl() {
    return this.showTwitter && this.twitterUrl
  }
}

export { User as default }
